module.exports = __webpack_public_path__ + "img/BlendBuff-Confusion.efa90b69.png";